import { render, staticRenderFns } from "./brainsAutocomplete.vue?vue&type=template&id=d82aeb20&scoped=true&"
import script from "./brainsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./brainsAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./brainsAutocomplete.vue?vue&type=style&index=0&id=d82aeb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82aeb20",
  null
  
)

export default component.exports